import React from 'react'
import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    Typography,
} from '@mui/material'
import LoadingButton from '@mui/lab/LoadingButton'
import SearchIcon from '@mui/icons-material/Search'
import CloseIcon from '@mui/icons-material/Close'
import FilterFields from './FilterFields'

export default function FilterModal({ open, onClose, onConfirm, selectedDate, onDateChange, hasAnalyticsPro, unidadeList, unidade, onUnidadeChange, loading }) {
    return (
        <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
            <DialogTitle sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', pr: 1 }}>
                Selecione o período e as unidades
                <IconButton aria-label="Fechar" onClick={onClose}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers>
                <Typography variant="body2" color="text.secondary" mb={2}>
                    Informe o mês/ano e as unidades para carregar os dados do dashboard.
                </Typography>
                <FilterFields
                    selectedDate={selectedDate}
                    onDateChange={onDateChange}
                    hasAnalyticsPro={hasAnalyticsPro}
                    unidadeList={unidadeList}
                    unidade={unidade}
                    onUnidadeChange={onUnidadeChange}
                />
            </DialogContent>
            <DialogActions sx={{ px: 3, py: 2 }}>
                <LoadingButton
                    variant="contained"
                    startIcon={<SearchIcon />}
                    onClick={onConfirm}
                    loading={loading}
                    loadingIndicator="Buscando..."
                    loadingPosition="center"
                    size="large"
                    fullWidth
                >
                    Buscar
                </LoadingButton>
            </DialogActions>
        </Dialog>
    )
}
